import React from "react";

import { ICONS } from "@/components/icons";

import styles from "./search-input.module.scss";

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
    value,
    onChange,
    placeholder = "Search help",
    className = "",
}) => {
    return (
        <div className={`${styles.root} ${className}`.trim()}>
            <div className={styles.iconWrapper}>
                <ICONS.Search color="rgb(153, 153, 153)" />
            </div>
            <input
                className={styles.input}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                type="text"
            />
        </div>
    );
};
